console.group("inicializando o pack js do app")

import 'jquery-mask-plugin';
import '../vendor/js/foundation.js';
import "../channels/notifications_channel"
import "../channels/connection_instance_monitor.js";
import 'slick-carousel';

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

/* FIXME: Até fazer a portabilidade completa dos js para compilar em ES6 */
import PollingManager from '../js/polling_helper.js';
import SimpleMenu from '../js/simple_menu.js';
import M from '../js/msg_helper.js.erb';
import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';


import {
    default as ContextToolbar,
    Toolbar,
    SearchBar
} from '../js/toolbars.js';

import {
    default as scriptLoader,
    toastAlert,
    countChar,
    getExtendedMonth,
    getExtendedWeekday,
    extendedDate,
    brazilianDate,
    parseAddressInLines,
    parseAddressAsHtml,
    requireSignIn
} from "../js/helpers.js";

// Sistema avançado de PWA com gerenciamento de cache e segurança
class PWAManager {
    constructor() {
        this.currentUser = null;
        this.registration = null;
        this.updateAvailable = false;
        this.reloaded = false;
        this.updateCheckInterval = null;
        
        this.init();
    }
    
    async checkAuthState() {
        try {
            // Faz uma requisição para verificar o estado atual do usuário
            const response = await fetch('/pwa/current_user_data', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            });
            
            if (response.ok) {
                const userData = await response.json();
                this.handleAuthStateResponse(userData);
            } else if (response.status === 401) {
                // Usuário não autenticado
                this.handleUserLogout();
            }
        } catch (error) {
            console.warn('[PWA] Erro ao verificar estado de autenticação:', error);
        }
    }
    
    async init() {
        if (!('serviceWorker' in navigator)) {
            console.warn('[PWA] Service Worker não suportado');
            return;
        }
        
        await this.registerServiceWorker();
        this.setupUserChangeDetection();
        this.setupUpdateChecking();
        this.setupNetworkMonitoring();
        this.setupVisibilityChangeHandling();
        
        // Integra com sistema de atualizações imediatas
        if (window.pwaImmediateUpdates) {
            window.pwaImmediateUpdates.addUpdateListener((type, data) => {
                this.handleImmediateUpdate(type, data);
            });
        }
        
        // Integra com sistema de atualizações em segundo plano
        if (window.pwaBackgroundUpdates) {
            window.pwaBackgroundUpdates.addUpdateListener((type, data) => {
                this.handleBackgroundUpdate(type, data);
            });
        }
    }
    
    async registerServiceWorker() {
        try {
            this.registration = await navigator.serviceWorker.register('/service-worker.js');
            console.log('[PWA] Service Worker registrado');
            
            // Verifica atualizações imediatamente
            if (this.registration.update) {
                await this.registration.update();
            }
            
            // Configura listeners para atualizações
            this.setupUpdateListeners();
            
            // Força ativação se há SW em waiting
            if (this.registration.waiting) {
                this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
            
        } catch (error) {
            console.error('[PWA] Erro ao registrar Service Worker:', error);
        }
    }
    
    setupUpdateListeners() {
        // Detecta novo SW encontrado
        this.registration.addEventListener('updatefound', () => {
            const newWorker = this.registration.installing;
            if (!newWorker) return;
            
            console.log('[PWA] Nova versão encontrada');
            this.updateAvailable = true;
            
            newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    console.log('[PWA] Nova versão pronta para ativação');
                    this.showUpdateNotification();
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                }
            });
        });
        
        // Detecta mudança de controller (nova versão ativada)
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (this.reloaded) return;
            this.reloaded = true;
            
            console.log('[PWA] Nova versão ativada, recarregando...');
            this.clearUserData();
            window.location.reload();
        });
        
        // Escuta mensagens do Service Worker sobre atualizações
        navigator.serviceWorker.addEventListener('message', (event) => {
            this.handleServiceWorkerMessage(event.data);
        });
    }
    
    setupUserChangeDetection() {
        // Detecta mudança de usuário via localStorage
        this.currentUser = this.getCurrentUserId();
        
        // Monitora mudanças no localStorage
        window.addEventListener('storage', (event) => {
            if (event.key === 'current_user_id' || event.key === 'user_session') {
                this.handleUserChange();
            }
        });
        
        // Monitora mudanças via eventos customizados
        window.addEventListener('user:login', () => this.handleUserLogin());
        window.addEventListener('user:logout', () => this.handleUserLogout());
        window.addEventListener('user:change', () => this.handleUserChange());
    }
    
    setupUpdateChecking() {
        // Verifica atualizações a cada 30 minutos
        this.updateCheckInterval = setInterval(() => {
            this.checkForUpdates();
        }, 30 * 60 * 1000);
        
        // Verifica quando a aba fica visível
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                this.checkForUpdates();
            }
        });
    }
    
    setupNetworkMonitoring() {
        window.addEventListener('online', () => {
            console.log('[PWA] Conexão restaurada');
            this.refreshOfflineContent();
            this.checkForUpdates();
        });
        
        window.addEventListener('offline', () => {
            console.log('[PWA] Conexão perdida');
        });
    }
    
    setupVisibilityChangeHandling() {
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                // Verifica se o usuário mudou enquanto a aba estava oculta
                const currentUserId = this.getCurrentUserId();
                if (currentUserId !== this.currentUser) {
                    this.handleUserChange();
                }
            }
        });
    }
    
    getCurrentUserId() {
        // Tenta várias fontes para identificar o usuário atual
        return localStorage.getItem('current_user_id') || 
               sessionStorage.getItem('current_user_id') ||
               this.extractUserIdFromDOM() ||
               this.extractUserIdFromCookies();
    }
    
    extractUserIdFromDOM() {
        const userElement = document.querySelector('[data-user-id]');
        return userElement ? userElement.dataset.userId : null;
    }
    
    extractUserIdFromCookies() {
        const match = document.cookie.match(/user_id=([^;]+)/);
        return match ? match[1] : null;
    }
    
    async handleUserLogin() {
        console.log('[PWA] Usuário logado');
        const newUserId = this.getCurrentUserId();
        
        if (newUserId && newUserId !== this.currentUser) {
            await this.clearPreviousUserCache();
            this.currentUser = newUserId;
        }
    }
    
    async handleUserLogout() {
        console.log('[PWA] Usuário deslogado');
        await this.clearAllUserCache();
        this.currentUser = null;
    }
    
    async handleUserChange() {
        const newUserId = this.getCurrentUserId();
        
        if (newUserId !== this.currentUser) {
            console.log(`[PWA] Mudança de usuário detectada: ${this.currentUser} -> ${newUserId}`);
            
            // Limpa cache do usuário anterior
            if (this.currentUser) {
                await this.clearUserSpecificCache(this.currentUser);
            }
            
            // Limpa dados sensíveis do navegador
            await this.clearSensitiveData();
            
            this.currentUser = newUserId;
            
            // Força reload para garantir dados limpos
            window.location.reload();
        }
    }
    
    async clearUserSpecificCache(userId) {
        if (!navigator.serviceWorker.controller) return;
        
        navigator.serviceWorker.controller.postMessage({
            type: 'CLEAR_USER_CACHE',
            data: { userId }
        });
        
        console.log(`[PWA] Cache do usuário ${userId} limpo`);
    }
    
    async clearPreviousUserCache() {
        if (!navigator.serviceWorker.controller) return;
        
        navigator.serviceWorker.controller.postMessage({
            type: 'CLEAR_ALL_CACHE'
        });
        
        console.log('[PWA] Cache de usuário anterior limpo');
    }
    
    async clearAllUserCache() {
        await this.clearPreviousUserCache();
        await this.clearSensitiveData();
    }
    
    handleServiceWorkerMessage(data) {
        if (!data || !data.type) return;
        
        switch (data.type) {
            case 'SW_UPDATE_AVAILABLE':
                this.handleUpdateAvailable(data);
                break;
                
            case 'SW_UPDATED':
                this.handleUpdateCompleted(data);
                break;
                
            case 'SW_UPDATE_ERROR':
                this.handleUpdateError(data);
                break;
                
            default:
                console.log('[PWA] Mensagem do SW:', data);
        }
    }
    
    handleUpdateAvailable(data) {
        console.log(`[PWA] Atualização disponível: ${data.version}`);
        
        // Mostra notificação discreta
        this.showUpdateNotification('Atualizando aplicação...', 'info');
        
        // Não requer ação do usuário - atualização automática em andamento
    }
    
    handleUpdateCompleted(data) {
        console.log(`[PWA] Atualização concluída: ${data.version}`);
        
        if (data.action === 'reload_required') {
            // Mostra notificação de que a atualização foi aplicada
            this.showUpdateNotification('Aplicação atualizada! Recarregando...', 'success');
            
            // Aguarda um pouco para o usuário ver a notificação
            setTimeout(() => {
                this.clearUserData();
                window.location.reload();
            }, 2000);
        }
    }
    
    handleUpdateError(data) {
        console.warn('[PWA] Erro na atualização:', data.error);
        this.showUpdateNotification('Erro na atualização. Tentando novamente...', 'warning');
    }

    async clearSensitiveData() {
        // Limpa localStorage (exceto configurações do app)
        const keysToKeep = ['app_theme', 'app_language', 'pwa_settings'];
        const allKeys = Object.keys(localStorage);
        
        allKeys.forEach(key => {
            if (!keysToKeep.includes(key)) {
                localStorage.removeItem(key);
            }
        });
        
        // Limpa sessionStorage completamente
        sessionStorage.clear();
        
        // Limpa IndexedDB se existir
        if ('indexedDB' in window) {
            try {
                const databases = await indexedDB.databases();
                await Promise.all(
                    databases.map(db => {
                        return new Promise((resolve, reject) => {
                            const deleteReq = indexedDB.deleteDatabase(db.name);
                            deleteReq.onsuccess = () => resolve();
                            deleteReq.onerror = () => reject(deleteReq.error);
                        });
                    })
                );
            } catch (error) {
                console.warn('[PWA] Erro ao limpar IndexedDB:', error);
            }
        }
        
        console.log('[PWA] Dados sensíveis limpos');
    }
    
    async clearUserData() {
        console.log('[PWA] Limpando dados do usuário para nova versão');
        
        // Limpa cache de usuário específico
        if (this.currentUser) {
            await this.clearUserSpecificCache(this.currentUser);
        }
        
        // Limpa todos os dados sensíveis
        await this.clearSensitiveData();
        
        // Reseta o usuário atual
        this.currentUser = null;
        
        console.log('[PWA] Dados do usuário limpos');
    }
    
    async checkForUpdates() {
        if (!this.registration) return;
        
        try {
            await this.registration.update();
            
            if (navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({
                    type: 'CHECK_UPDATE'
                });
            }
        } catch (error) {
            console.warn('[PWA] Erro ao verificar atualizações:', error);
        }
    }
    
    refreshOfflineContent() {
        if (!navigator.serviceWorker.controller) return;
        
        navigator.serviceWorker.controller.postMessage({
            type: 'REFRESH_OFFLINE'
        });
    }
    
    showUpdateNotification(message = 'Nova versão disponível', type = 'info', showActions = false) {
        // Remove notificação anterior se existir
        const existing = document.querySelector('.pwa-update-notification');
        if (existing) existing.remove();
        
        // Cria notificação discreta de atualização
        const notification = document.createElement('div');
        notification.className = `pwa-update-notification pwa-notification-${type}`;
        
        let actionsHtml = '';
        if (showActions) {
            actionsHtml = `
                <button onclick="window.pwaManager.applyUpdate()">Atualizar</button>
                <button onclick="this.parentElement.parentElement.remove()">×</button>
            `;
        } else {
            // Auto-remove após 5 segundos para notificações informativas
            setTimeout(() => {
                if (notification.parentElement) {
                    notification.remove();
                }
            }, 5000);
        }
        
        notification.innerHTML = `
            <div class="pwa-update-content">
                <span>${message}</span>
                ${actionsHtml}
            </div>
        `;
        
        // Adiciona estilos se não existirem
        if (!document.querySelector('#pwa-update-styles')) {
            const styles = document.createElement('style');
            styles.id = 'pwa-update-styles';
            styles.textContent = `
                .pwa-update-notification {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    color: white;
                    padding: 12px 16px;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                    z-index: 10000;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                    font-size: 14px;
                    max-width: 300px;
                    animation: slideIn 0.3s ease-out;
                }
                .pwa-notification-info {
                    background: #007bff;
                }
                .pwa-notification-success {
                    background: #28a745;
                }
                .pwa-notification-warning {
                    background: #ffc107;
                    color: #212529;
                }
                .pwa-notification-error {
                    background: #dc3545;
                }
                .pwa-update-content {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                .pwa-update-content span {
                    flex: 1;
                }
                .pwa-update-content button {
                    background: rgba(255,255,255,0.2);
                    border: none;
                    color: inherit;
                    padding: 6px 12px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 12px;
                    transition: background 0.2s;
                }
                .pwa-update-content button:hover {
                    background: rgba(255,255,255,0.3);
                }
                .pwa-notification-warning button {
                    background: rgba(0,0,0,0.1);
                }
                .pwa-notification-warning button:hover {
                    background: rgba(0,0,0,0.2);
                }
                @keyframes slideIn {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
            `;
            document.head.appendChild(styles);
        }
        
        document.body.appendChild(notification);
    }
    
    applyUpdate() {
        if (this.registration && this.registration.waiting) {
            this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        
        // Remove notificação
        const notification = document.querySelector('.pwa-update-notification');
        if (notification) notification.remove();
    }
    
    async getCacheInfo() {
        return new Promise((resolve) => {
            if (!navigator.serviceWorker.controller) {
                resolve(null);
                return;
            }
            
            const channel = new MessageChannel();
            channel.port1.onmessage = (event) => {
                resolve(event.data);
            };
            
            navigator.serviceWorker.controller.postMessage({
                type: 'GET_CACHE_INFO'
            }, [channel.port2]);
        });
    }
    
    // Lida com atualizações imediatas
    handleImmediateUpdate(type, data) {
        console.log(`[PWA Manager] Atualização imediata: ${type}`, data);
        
        switch (type) {
            case 'version-changed':
                this.handleVersionChange(data);
                break;
            case 'user-changed':
                this.handleUserChange(data.oldUserId, data.newUserId);
                break;
            case 'cache-cleared':
                this.showUpdateNotification('Cache limpo com sucesso', 'success');
                break;
            case 'update-error':
                this.showUpdateNotification('Erro ao verificar atualizações', 'error');
                break;
        }
    }
    
    // Lida com atualizações em segundo plano
    handleBackgroundUpdate(type, data) {
        console.log(`[PWA Manager] Atualização em segundo plano: ${type}`, data);
        
        switch (type) {
            case 'updates-found':
                this.handleBackgroundUpdatesFound(data);
                break;
            case 'pwa-updated':
                this.handleBackgroundPWAUpdate(data);
                break;
            case 'cache-updated':
                this.handleBackgroundCacheUpdate(data);
                break;
            case 'user-changed':
                this.handleBackgroundUserChange(data);
                break;
            case 'sw-update-available':
                this.handleServiceWorkerUpdate(data);
                break;
            case 'update-error':
                this.handleBackgroundUpdateError(data);
                break;
        }
    }
    
    // Lida com atualizações encontradas em segundo plano
    handleBackgroundUpdatesFound(data) {
        if (!data.hasUpdates) return;
        
        console.log('[PWA Manager] Atualizações encontradas em segundo plano:', data);
        
        // Se a aba está visível, pode mostrar notificação discreta
        if (!document.hidden) {
            let message = 'Atualizações disponíveis';
            
            if (data.updateTypes.pwa) {
                message = 'Nova versão da aplicação disponível';
            } else if (data.updateTypes.cache) {
                message = 'Conteúdo atualizado disponível';
            } else if (data.updateTypes.user) {
                message = 'Dados do usuário foram atualizados';
            }
            
            this.showUpdateNotification(message, 'info', 5000);
        }
    }
    
    // Lida com atualização do PWA em segundo plano
    handleBackgroundPWAUpdate(data) {
        console.log('[PWA Manager] PWA atualizado em segundo plano');
        
        // Atualiza configuração local
        if (window.PWA_CONFIG && data.serverVersions) {
            window.PWA_CONFIG.pwa_version = data.serverVersions.pwa_version;
        }
        
        // Mostra notificação se a aba está visível
        if (!document.hidden) {
            this.showUpdateNotification('Aplicação atualizada com sucesso', 'success');
        }
    }
    
    // Lida com atualização do cache em segundo plano
    handleBackgroundCacheUpdate(data) {
        console.log('[PWA Manager] Cache atualizado em segundo plano');
        
        // Atualiza configuração local
        if (window.PWA_CONFIG && data.serverVersions) {
            window.PWA_CONFIG.cache_version = data.serverVersions.cache_version;
        }
    }
    
    // Lida com mudança de usuário em segundo plano
    handleBackgroundUserChange(data) {
        console.log('[PWA Manager] Mudança de usuário detectada em segundo plano');
        
        // Se detectou mudança de usuário, força reload da página
        if (data.serverVersions && data.currentVersions) {
            const serverUserId = data.serverVersions.user_id;
            const currentUserId = data.currentVersions.user_id;
            
            if (serverUserId !== currentUserId) {
                console.log('[PWA Manager] Usuário mudou, recarregando página');
                this.showUpdateNotification('Sessão atualizada, recarregando...', 'info', 2000);
                
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
        }
    }
    
    // Lida com atualização do Service Worker
    handleServiceWorkerUpdate(data) {
        console.log('[PWA Manager] Service Worker atualizado');
        
        if (!document.hidden) {
            this.showUpdateNotification('Sistema atualizado', 'success');
        }
    }
    
    // Lida com erros de atualização em segundo plano
    handleBackgroundUpdateError(data) {
        console.warn('[PWA Manager] Erro em atualização de segundo plano:', data);
        
        // Só mostra erro se for crítico ou muitas tentativas
        if (data.retryCount >= 3) {
            this.showUpdateNotification('Erro ao verificar atualizações', 'error', 3000);
        }
    }
    
    destroy() {
        if (this.updateCheckInterval) {
            clearInterval(this.updateCheckInterval);
        }
    }
}

// Inicializa o PWA Manager
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        window.pwaManager = new PWAManager();
    });
}


global.M = M

global.PollingManager = PollingManager
global.SimpleMenu = SimpleMenu
global.ContextToolbar = ContextToolbar
global.Toolbar = Toolbar
global.SearchBar = SearchBar
global.scriptLoader = scriptLoader
global.toastAlert = toastAlert
global.countChar = countChar
global.getExtendedMonth = getExtendedMonth
global.getExtendedWeekday = getExtendedWeekday
global.extendedDate = extendedDate
global.brazilianDate = brazilianDate
global.parseAddressInLines = parseAddressInLines
global.parseAddressAsHtml = parseAddressAsHtml
global.requireSignIn = requireSignIn
global.Calendar = Calendar
global.dayGridPlugin = dayGridPlugin
global.timeGridPlugin = timeGridPlugin
global.interactionPlugin = interactionPlugin
// Faz o bridge do Masonry para virar um plugin jQuery
jQueryBridget('masonry', Masonry, $);

document.addEventListener("turbo:load", function () {
    console.log("🚀 turbo:load acionado");
    Notifications.init();
})

const token = $('meta[name="csrf-token"]').attr('content');

if (token) {
    $.ajaxSetup({
        headers: { 'X-CSRF-Token': token }
    });
}

console.groupEnd()

console.group("inicializando componentes js do app")

console.groupEnd()